// PROD
const firebaseConfig = {
  apiKey: "AIzaSyCkGFKgcGLJz-msO47ZCFF2nOZ-JI8Qxoo",
  authDomain: "skrutiner-platform.firebaseapp.com",
  projectId: "skrutiner-platform",
  storageBucket: "skrutiner-platform.firebasestorage.app",
  messagingSenderId: "755090413409",
  appId: "1:755090413409:web:13584369dec9b9db2fd720"
};

export default firebaseConfig;
